import SearchableSelect from './SearchableSelect';
import styles from './Paginacion.module.css';

// Pie de paginación en su PROPIA tarjeta, aparte de la tabla (el diseño de Asambleas). Es el único
// diseño: se cambia aquí y cambia en todas las pantallas. No pagina por sí solo: el padre corta la
// lista (en el navegador o pidiéndola al servidor) y aquí solo se muestran los controles.
// Si todo cabe en una página no se pinta nada. `arriba` = copia que va ANTES de la tabla (separa
// por debajo); sin `arriba` va DESPUÉS (separa por encima).
// Opcional: `opcionesPorPagina` (p. ej. [10, 25, 50, 100]) + `onCambiarPorPagina(n)` agregan el
// selector «Por página». Con selector la barra no desaparece aunque quepa todo en una sola página
// (si no, tras elegir un tamaño grande no habría cómo volver a uno chico).
export default function Paginacion({ pagina, total, porPagina, onCambiar, arriba, opcionesPorPagina, onCambiarPorPagina }) {
  const conSelector = Array.isArray(opcionesPorPagina) && typeof onCambiarPorPagina === 'function';
  const ultima = Math.max(1, Math.ceil(total / porPagina));
  if (ultima <= 1 && !(conSelector && total > Math.min(...opcionesPorPagina))) return null;
  const numeros = Array.from({ length: ultima }, (_, i) => i + 1)
    .filter(n => n === 1 || n === ultima || Math.abs(n - pagina) <= 1)
    .reduce((acc, n, i, arr) => { if (i > 0 && n - arr[i - 1] > 1) acc.push('...'); acc.push(n); return acc; }, []);
  return (
    <div className={`card ${arriba ? styles.tarjetaArriba : styles.tarjetaAbajo}`}>
    <nav aria-label="Paginación" className={styles.barra}>
      <span className={styles.resumen}>Página {pagina} de {ultima} — {total} registros</span>
      <div className={styles.controles}>
        {conSelector && (
          <label className={styles.porPagina}>
            Por página
            <SearchableSelect value={String(porPagina)} onChange={(v) => onCambiarPorPagina(Number(v))} auto allowEmpty={false}
              minWidth={64} maxWidth={90} ariaLabel="Por página" triggerClassName={styles.selectorPorPagina}
              options={opcionesPorPagina.map(n => ({ value: n, label: String(n) }))} />
          </label>
        )}
        {ultima > 1 && <>
        <button type="button" className="btn btn-sm btn-secondary" onClick={() => onCambiar(Math.max(1, pagina - 1))}
          disabled={pagina === 1} aria-label="Página anterior">
          <i className="fas fa-chevron-left" />
        </button>
        {numeros.map((n, i) => n === '...'
          ? <span key={`e${i}`} className={styles.puntos}>…</span>
          : <button type="button" key={n} className={`btn btn-sm ${n === pagina ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => onCambiar(n)} aria-current={n === pagina ? 'page' : undefined}>{n}</button>
        )}
        <button type="button" className="btn btn-sm btn-secondary" onClick={() => onCambiar(Math.min(ultima, pagina + 1))}
          disabled={pagina === ultima} aria-label="Página siguiente">
          <i className="fas fa-chevron-right" />
        </button>
        </>}
      </div>
    </nav>
    </div>
  );
}
